// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"animations-module__fadeIn___ywGcv"};